import { BaseModel } from '@/api/base-model'
import { SourceAPI } from '@/api/backend-client'
import { ReferralChannel } from '@/api/types'
import { Company } from '@/api/model/company'

export class Source extends BaseModel<Source> {
    protected collectionName = SourceAPI.collectionName

    static EMMA = 'emma'
    static SMART_MARKETING = 'smart-marketing'
    static TYPEFORM = 'enquête'

    constructor(
        public company: Company,
        public id: string,
        public name: string,
        public active: boolean,
        public channel: ReferralChannel,
    ) { super(id) }

    static fromData(data: any): Source {
        if (data === null || typeof data === 'string' || data instanceof Source) {
            return data
        }

        return new Source(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.name,
            data.active,
            data.channel,
        )
    }

    get isEmmaSource(): boolean {
        return this.active && this.name.toLowerCase() === Source.EMMA
    }

    get isSmartMarketingSource(): boolean {
        return this.active && this.name.toLowerCase() === Source.SMART_MARKETING
    }

    get isTypeformSource(): boolean {
        return this.active && this.name.toLowerCase() === Source.TYPEFORM
    }

    get isStaticSource(): boolean {
        return this.isEmmaSource ||
               this.isSmartMarketingSource ||
               this.isTypeformSource
    }

    get isEditable(): boolean {
        return !this.isEmmaSource
            && !this.isSmartMarketingSource
            && !this.isTypeformSource
    }
}
